export default __webpack_public_path__ + "static/media/checked-icon-green.7eaf9bbf.svg";